import { Row, Tag } from 'antd'
import type {
  DocumentFragment,
  DocumentRuleSeverity,
  DocumentRuleType,
} from '~app/graph/generated/graphql'
import i18n from '~app/i18n/i18n'

/**
 * Utils
 */

const colorFromRuleSeverity = (severity: DocumentRuleSeverity) => {
  switch (severity) {
    case 'Info':
      return 'geekblue'
    case 'Warning':
      return 'orange'
    case 'Error':
      return 'red'
    default:
      throw new Error('Severity type unknown')
  }
}

interface RuleWarning {
  ruleKey: string
  label: string
  severity: DocumentRuleSeverity
}

/**
 * Returns config for warnings based on existing rules
 */
const getWarnings = (
  rules: {
    severity: DocumentRuleSeverity
    type: DocumentRuleType
  }[]
): RuleWarning[] =>
  rules.map(({ type, severity }) => ({
    // label falls back to DocumentRuleType-type when no translation match
    label: i18n.t(`documentView.${type}`, type),
    ruleKey: type,
    severity,
  }))

/**
 * Component
 */

interface Props {
  rules: DocumentFragment['rules']
}

type InnerProps = Props

const RuleWarnings = ({ rules }: InnerProps) => {
  const warnings = getWarnings(rules)
  return warnings.length > 0 ? (
    <Row style={{ display: 'flex' }} gutter={16}>
      {i18n.t('documentView.pleaseCheck')}
      <div style={{ marginLeft: 15 }}>
        {warnings.map(({ ruleKey, severity, label }) => (
          <Tag key={ruleKey} color={colorFromRuleSeverity(severity)}>
            {label}
          </Tag>
        ))}
      </div>
    </Row>
  ) : null
}
export default RuleWarnings
